/**
 * withProductDetailAttr
 * HOC for wrapping the provided component with ProductDetialAttrProvider
 */

import React from 'react'

import ProductDetailAttrProvider from './product-detail-attr-provider'

export default function withProductDetailAttr (WrappedComponent) {
  return function withProductDetailAttrProviderHOC(props) {
    return (
      <ProductDetailAttrProvider {...props}>
        <WrappedComponent {...props} />
      </ProductDetailAttrProvider>
    )
  }
}
